import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/missions/mission_a_distance@2x.jpg")